export const loadScript = scriptUrl =>
    new Promise(((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = scriptUrl;
        script.onerror = reject;
        script.onload = () => {
            const isLoaded = true;
            resolve(isLoaded);
        };

        document.head.appendChild(script);
    }));

export const loadStyle = (styleUrl) => {
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = styleUrl;
    document.head.appendChild(link);
};
